// src/i18n/i18n.js

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

i18n.use(Backend).use(initReactI18next).init({
  fallbackLng: 'vi',
  supportedLngs: ['vi', 'en'],
  resources: {
    en: {
      translation: {
        welcome: 'We hope you have a wonderful day',
        account_register: 'Account register',
        bernard: 'BERNARD INTERNATIONAL SPECIALIZED HEALTHCARE SYSTEM',
        bernard_ningendock: 'MEMBER OF JAPAN SOCIETY OF NINGEN DOCK',
        say_hi: 'Greetings from Bernard Healthcare!',  
        do_not_have_account: 'If you do not have an account, please click Register.',
        do_not_have_account_please_press: 'If you do not have an account, please click to',
        have_account: 'If you already have an account, please Sign In',
        enter_phone_number: 'Please enter your phone number/ patient identification *',
        enter_password: 'Password *',
        remember: 'Remember me',
        signin: 'Sign In',
        login_fail: 'Login failed',
        login_fail_message: "Please check your login information. If you don't have account, please click <0>Register</0>. Contact <1>02835352468</1> or hotline <2>0911072200</2> for support. Thank you.",
        forgot_password_result_success_title: 'Success',
        forgot_password_result_success_message: 'Your password has been reset, please check message on your phone. Contact 02835352468 or hotline 0911072200 for support. Thank you.',
        close: 'Close',
        enter_login_info: 'Please enter registration information',
        phone_number: 'Phone number or PID *',
        phonenumber: 'Phone number',
        full_name: 'Full name',
        register: 'Register',
        register_fail: 'Error registering',
        register_fail_message: 'Your phone number is not registered. Please contact <0>02835352468</0> or hotline <1>0911072200</1> for support.',
        support_info: 'Please contact <0>02835352468</0> or hotline <1>0911072200</1> (from 07:30 to 17:00) for support. Thank you.',
        confirm_booking: 'Thank you for your health check registration at Bernard Healthcare. Please present at <0></0> at <1></1> on <2></2>.',
        register_exist: 'Account already exists',
        register_exist_message: 'You already have account, please <0>Sign in</0> to make appointment.',
        password_changed: 'Đổi mật khẩu thành công',
        password_changed_message: 'Your password has been changed successfully',
        change_password: 'Change password',
        enter_new_password: 'Please enter your new password',
        new_password: 'New password *',
        retype_new_password: 'Confirm new password',
        continue_signin: 'Already have account, continue to login',
        password_not_match: 'Password not match',
        health_checkup: 'CORPORATE HEALTH CHECK-UP',
        contract_code: 'Contract code',
        company_name: 'Company name',
        working_hour: 'Opening hours: from Monday to Saturday',
        make_appointment: 'MAKE AN APPOINTMENT',
        working_afternoon: 'Afternoon: 13:00 - 17:00',
        working_morning: 'Morning: 07:30 - 11:30',
        registration_hour: 'Registration hours:',
        registration_morning: 'Morning: 07:30 - 9:30',
        registration_afternoon: 'Afternoon: 13:00 - 15:30',
        choose_clinic: 'Choose one of our clinics:',
        bernard_1: 'Bernard 1: 201 Nam Ky Khoi Nghia, District 3, Ho Chi Minh City',
        bernard_2: 'Bernard 2: 22 Phan Dinh Giot, Ward 2, Tan Binh District, Ho Chi Minh City',
        bnd_1: 'Bernard 1, 201 Nam Ky Khoi Nghia, District 3, Ho Chi Minh City',
        bnd_2: 'Bernard 2, 22 Phan Dinh Giot, Ward 2, Tan Binh District, Ho Chi Minh City',
        times_of_day: 'Times of day',
        booking_date: 'Booking date',
        booking_now: 'Book now',
        morning: 'Morning',
        afternoon: 'Afternoon',
        customer_info: 'CUSTOMER INFO',
        health_check_tab: 'Health check appointment',
        health_check_result: 'Health check result',
        under_construction: 'Under construction',
        booking_fail: 'Booking unsuccessful',
        password: 'Password',
        forgot_password: 'Forgot password?',
        reset_password: 'Reset password',
        forgot_password_phone: 'Phone number *',
        forgot_password_enter_phone: 'Please enter your phone number',
        forgot_password_result_fail_title: 'Invalid phone number',
        forgot_password_result_fail_message: 'Your entered phone number is incorrect, please check or contact 02835352468 or hotline 0911072200 for support. Thank you.',
        bernard_website: 'Please visit our website for more information',
      }
    },
    vi: {
      translation: {
        welcome: 'Bernard Healthcare kính chúc Quý khách một ngày tốt lành',
        account_register: 'Đăng ký tài khoản',
        bernard: 'HỆ THỐNG Y KHOA CHUYÊN SÂU QUỐC TẾ BERNARD',
        bernard_ningendock: 'THÀNH VIÊN HIỆP HỘI NINGEN DOCK NHẬT BẢN',
        say_hi: 'Xin chào!',  
        do_not_have_account: 'Nếu chưa có tài khoản, vui lòng bấm để Đăng ký.',
        do_not_have_account_please_press: 'Nếu chưa có tài khoản, vui lòng bấm để',
        have_account: 'Nếu quý khách đã có tài khoản, xin vui lòng Đăng nhập',
        enter_phone_number: 'Vui lòng nhập số điện thoại/mã bệnh nhân *',
        forgot_password_phone: 'Vui lòng nhập số điện thoại *',
        enter_password: 'Nhập mật khẩu *',
        remember: 'Nhớ mật khẩu',
        signin: 'Đăng nhập',
        login_fail: 'Đăng nhập không thành công',
        login_fail_message: 'Quý khách vui lòng kiểm tra lại thông tin đăng nhập. Nếu chưa có tài khoản, vui lòng bấm <0>Đăng ký</0>. Quý khách vui lòng liên hệ số <1>02835352468</1> hoặc hotline <2>0911072200</2> nếu có yêu cầu hỗ trợ.',
        close: 'Đóng',
        enter_login_info: 'Quý khách vui lòng nhập thông tin đăng ký',
        phone_number: 'Số điện thoại / Mã bệnh nhân *',
        phonenumber: 'Số điện thoại',
        full_name: 'Họ và tên',
        register: 'Đăng ký',
        register_fail: 'Lỗi đăng ký tài khoản',
        register_fail_message: 'Số điện thoại của quý khách chưa được đăng ký. Quý khách vui lòng liên hệ số <0>02835352468</0> hoặc hotline <1>0911072200</1> để yêu cầu hỗ trợ.',
        booking_fail_message: 'Quý khách vui lòng kiểm tra lại thông tin đăng ký khám. Để yêu cầu hỗ trợ, Quý khách vui lòng liên hệ số <0>02835352468</0> hoặc hotline <1>0911072200</1>.',
        register_exist: 'Tài khoản đã đăng ký',
        register_exist_message: 'Số điện thoại của Quý khách đã được đăng ký, Quý khách vui lòng <0>Đăng nhập</0> để đặt lịch khám.',
        password_changed: 'Đổi mật khẩu thành công',
        password_changed_message: 'Mật khẩu của Quý khách đã được cập nhật.',
        change_password: 'Đổi mật khẩu',
        enter_new_password: 'Quý khách vui lòng đặt mật khẩu mới',
        new_password: 'Mật khẩu mới *',
        retype_new_password: 'Mật khẩu mới',
        continue_signin: 'Đã có tài khoản, vui lòng đăng nhập',
        password_not_match: 'Mật khẩu không trùng khớp',
        health_checkup: 'KHÁM SỨC KHỎE DOANH NGHIỆP',
        contract_code: 'Mã hợp đồng khám',
        company_name: 'Tên đơn vị',
        working_hour: 'Thời gian khám: từ T2 đến T7',
        make_appointment: 'ĐẶT LỊCH KHÁM SỨC KHỎE',
        working_morning: 'Buổi sáng: 07:30 - 11:30',
        working_afternoon: 'Buổi chiều: 13:00 - 17:00',
        registration_hour: 'Thời gian phát hồ sơ:',
        registration_morning: 'Buổi sáng: 07:30 - 09:30',
        registration_afternoon: 'Buổi chiều: 13:00 - 15:30',
        choose_clinic: 'Chọn cơ sở khám:',
        bernard_1: 'Cơ sở 1: 201 Nam Kỳ Khởi Nghĩa, P.7, Quận 3, TP.HCM',
        bernard_2: 'Cơ sở 2: 22 Phan Đình Giót, P.2, Tân Bình, TP.HCM',
        times_of_day: 'Ca khám',
        booking_date: 'Ngày khám',
        booking_now: 'Đặt lịch',
        morning: 'Sáng',
        afternoon: 'Chiều',
        customer_info: 'THÔNG TIN KHÁCH HÀNG',
        health_check_tab: 'Đăng ký lịch khám',
        health_check_result: 'Kết quả khám sức khỏe',
        under_construction: 'Chuyên mục này đang được cập nhật',
        booking_fail: 'Lỗi đăng ký lịch khám',
        support_info: 'Nếu có yêu cầu hỗ trợ, Quý khách vui lòng liên hệ số <0>02835352468</0> hoặc hotline <1>0911072200</1> (từ 07:30 đến 17:00).',
        confirm_booking: 'Cám ơn Quý khách đã đăng ký khám sức khỏe tại Bernard Healthcare. Quý khách vui lòng có mặt tại phòng khám <0></0> vào lúc <1></1> ngày <2></2>.',
        bnd_1: 'Bernard 1, số 201 Nam Kỳ Khởi Nghĩa, Quận 3, TP.HCM',
        bnd_2: 'Bernard 2, số 22 Phan Đình Giót, P.2, Q.Tân Bình, TP.HCM',
        password: 'Mật khẩu',
        forgot_password: 'Quên mật khẩu?',
        reset_password: 'Đặt lại mật khẩu',
        forgot_password_enter_phone: 'Vui lòng nhập số điện thoại',
        forgot_password_result_success_title: 'Đã đặt lại mật khẩu',
        forgot_password_result_fail_title: 'Thông tin không chính xác',
        forgot_password_result_fail_message: 'Số điện thoại của quý khách chưa được đăng ký, quý khách vui lòng kiểm tra hoặc liên hệ số 02835352468 hoặc hotline 0911072200 để được hỗ trợ. Cám ơn quý khách.',
        forgot_password_result_success_message: 'Mật khẩu mới đã được gửi qua tin nhắn đến số điện thoại đã đăng ký. Nếu có yêu cầu hỗ trợ, Quý khách vui lòng liên hệ số 02835352468 hoặc hotline 0911072200.',
        bernard_website: 'Quý khách vui lòng dành thời gian truy cập website Bernard Healthcare nếu cần tìm hiểu thêm thông tin về các dịch vụ và đội ngũ y tế của chúng tôi. Chân thành cảm ơn.'
      }
    },
  }
});

export default i18n;

export const LANGUAGES = [
  { label: "Tiếng Việt", code: "vi" },
  { label: "English", code: "en" },  
];